// Import the functions you need from the SDKs you need
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'
import 'firebase/compat/auth'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCIi-J6Lg4HJcXuROwTOVR9gxotD_BhAZ4",
  authDomain: "web-gallery-lanka.firebaseapp.com",
  projectId: "web-gallery-lanka",
  storageBucket: "web-gallery-lanka.appspot.com",
  messagingSenderId: "25255400767",
  appId: "1:25255400767:web:dc7920ea1084c8cf8bef8a",
  measurementId: "G-J7YBJX00B0"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
export const db=firebase.firestore();
export const storage=firebase.storage();
export const auth =firebase.auth();
// const analytics = getAnalytics(app);

